var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26697(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26697",
    "data-name": "Group 26697",
    transform: "translate(-884 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(884 788)",
    fill: "#c5b138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23255",
    "data-name": "Path 23255",
    d: "M624.647,102.052a2.343,2.343,0,0,1,2.345-2.345H669.2a2.345,2.345,0,1,1,0,4.69H626.992a2.343,2.343,0,0,1-2.345-2.345m35.511-30.631a9.38,9.38,0,0,1,4.265-1.026h4.206a2.83,2.83,0,0,1,2.653,3.825,15.1,15.1,0,0,1-7.387,8.207l-19.99,10a2.412,2.412,0,0,1-1.055.249H632.759a2.344,2.344,0,0,1-1.778-.821l-5.356-6.243a1.178,1.178,0,0,1,.365-1.817l2.357-1.172a2.335,2.335,0,0,1,2-.052l4.2,1.832,7.292-3.62-10.77-6.925a1.173,1.173,0,0,1,.11-2.034l3.362-1.682a4.678,4.678,0,0,1,3.744-.2L652.566,75.3Z",
    transform: "translate(272.353 737.357)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26697);
export default __webpack_public_path__ + "static/media/Group 26697.9f50e16966a140c852c8d316573ca0e4.svg";
export { ForwardRef as ReactComponent };